<kendo-dialog
  *ngIf="visible"
  [width]="'95vw'"
  [height]="'90vh'"
  [minWidth]="'800px'"
  [maxWidth]="'1400px'"
  (close)="onDialogClose()"
>
  <kendo-dialog-titlebar>Events & Escalations</kendo-dialog-titlebar>

  <div class="d-flex justify-content-start mb-2">
    <button
      type="button"
      kendoButton
      [disabled]="isExporting"
      class="cyflare-btn-secondary"
      (click)="triggerExport()"
    >
      Download CSV
    </button>
  </div>

  <kendo-tabstrip [keepTabContent]="true" (tabSelect)="onTabSelect($event)">
    <kendo-tabstrip-tab title="Events" [selected]="true">
      <ng-template kendoTabContent>
        <div class="table-wrap">
          <table id="eventsTable" class="table table-striped table-bordered" style="width: 100%"></table>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Escalations">
      <ng-template kendoTabContent>
        <div class="table-wrap">
          <table id="escalationsTable" class="table table-striped table-bordered" style="width: 100%"></table>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</kendo-dialog>
